import React, { useEffect, useState } from "react";
import { Search_icon, view_icon } from "../../assets/img";
// import { Select, MenuItem } from "@mui/material";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../components/Table/Table";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Select from "react-select";

function UserBookingTransaction({ user_id }) {
  const location = useLocation();
  const { paginationData, setpaginationData } = useGlobalContext();
  const path = location.pathname?.replace("/", "");
  const navigate = useNavigate();
  const [city, setCity] = useState("");

  const [searchs, setSearch] = useState("");
  const [selectedFilter, setSelectedFilter] = useState({
    search: paginationData?.[path]?.search ?? "",
    room_categories: paginationData?.[path]?.room_categories ?? "",
    property_id: paginationData?.[path]?.property_id,
    user_id: user_id,
  });

  // View toggles, filters, and data
  const [isData, setIsData] = useState([
    {
      SNo: "01",
      TransactionDate: "12/03/25",
      TransactionID: "VOWB00925",
      Property: "Sunshineashdjshjdsaj Villa VOWB00925",
      Owner: "Kumar VOWB00925",
      BookingId: "223322",
      ServiceType: "Room Booking",
      RoomType: "Deluxe",
      City: "Chennai",
      HotelCategory: "Villa",
      PropertyPrice: 1000,
      PaidAmount: 1000,
      BalanceAmount: 50,
      Slot: "22 hrs (M) (9am - 7am)",
      Status1: "Check In",
      Status2: "Booked",
    },
  ]);
  const [propertyID, setPropertyID] = useState("");
  const [optionsList, setOptionsList] = useState({
    properties: [],
  });
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const users = [
    { id: 1, name: "Chennai" },
    { id: 2, name: "Banglore" },
    { id: 3, name: "Hyderabad" },
    { id: 4, name: "Nellore" },
    { id: 5, name: "Guntur" },
  ];
  const columns = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => <p>{row.index + 1}</p>,
    },
    {
      Header: "Transaction date",
      accessor: "transaction_date",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Transaction Id",
      accessor: "transaction_id",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Property",
      accessor: "property_name",
      Cell: ({ value }) => <p style={{ color: "#AE55F5" }}>{value}</p>,
    },
    {
      Header: "Owner",
      accessor: "property",
      Cell: ({ value, row }) => <p>{value?.owner_name}</p>,
    },
    {
      Header: "BookingId",
      accessor: "booking_code",
      Cell: ({ value }) => <p>jsdjkashk{value}</p>,
    },
    {
      Header: "ServiceType",
      accessor: "service_type",
      Cell: ({ value }) => <p>{value || ""}</p>,
    },
    {
      Header: "RoomType",
      accessor: "room_category",
      Cell: ({ value }) => <p>{value}</p>,
    },
    { Header: "City", accessor: "city", Cell: ({ value }) => <p>{value}</p> },
    {
      Header: "HotelCategory",
      accessor: "hotel_category",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "PropertyPrice",
      accessor: "property_price",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "PaidAmount",
      accessor: "paid_amount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "BalanceAmount",
      accessor: "balance_amount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Slot",
      accessor: "slot",
      Cell: ({ value }) => <p style={{ width: "145px" }}>{value}</p>,
    },
    {
      Header: "Status1",
      accessor: "current_status",
      Cell: ({ value }) => (
        <p
          style={{
            background: value !== "-" ? "#5D5FEF" : "",
            color: value !== "-" ? "#fff" : "#000",
            padding: "10px 20px",
            borderRadius: 9,
            padding: "10px 1px",
            borderRadius: "9px",
            width: "100%",
            textAlign: "center",
          }}
        >
          {value || "-"}
        </p>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <p
          style={{
            background:
              value === "User Booked"
                ? "#5D5FEF"
                : value === "Hold"
                  ? "#FFA721"
                  : "red",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: 9,
          }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "View",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          <button
            onClick={() =>
              navigate("/customer-view", {
                state: {
                  type: { ...row.original, ...row.original?.user_details },
                },
              })
            }
            className="cust-btn"
          >
            <img src={view_icon} alt="View" className="edit-btn" />
          </button>
        </div>
      ),
    },
  ];
  const getProperties = async () => {
    const res = await get(URLS.PROPERTIES_DROPDOWN);
    console.log("properties dropdown", res);
    if (res?.status == "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, properties: modifiedList }));
    }
  };

  const getList = async (pageNumber = 1) => {
    const { property_id, room_categories, search, user_id } = selectedFilter;

    let payload = {
      user_id: user_id,
    };
    if (property_id) {
      payload["property_id"] = property_id?.value;
    }
    if (search) {
      payload["search"] = search;
    }
    if (room_categories) {
      payload["room_categories"] = room_categories;
    }
    const res = await post(
      `${URLS.USER_TRANSACTION}?page=${pageNumber}`,
      payload,
    );
    console.log("booking view list", res, res?.data);
    if (res?.status === "success") {
      // const modifiedList = res?.room_list?.map((item) => {
      //   return { value: item?.id, label: item?.name };
      // });
      // setPropertyDetails({
      //   ...res?.property,
      //   count: res?.count,
      //   room_list: modifiedList,
      // });
      setPagination({
        current_page: pageNumber,
        last_page: res?.next ? pageNumber + 1 : pageNumber,
      });
      setIsData(res?.data);
      // setBookingList(res?.bookings ?? []);
    }
  };
  useEffect(() => {
    const { search, room_categories, property_id } = selectedFilter;
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        page: page,
        search: search,
        room_categories: room_categories,
        property_id: property_id,
      },
    }));
  }, [
    selectedFilter?.room_categories,
    selectedFilter?.property_id,
    selectedFilter?.search,
    page,
  ]);
  const handleChangeFilter = (name, val) => {
    console.log("SDKASDKAKS", name, val);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  useEffect(() => {
    getProperties();
  }, []);
  console.log("optionsList", selectedFilter);

  return (
    <>
      <div
        style={{
          flexDirection: "row",
          justifyContent: "flex-end",
          //   justifyContent: "space-between",
          display: "flex",
          gap: 30,
        }}
      >
        <div style={{ display: "flex", gap: 20 }}>
          <Select
            className="location-search"
            options={optionsList?.properties || []}
            //   value={state}
            //   onChange={setState}
            value={selectedFilter?.property_id}
            onChange={(e) => {
              handleChangeFilter("property_id", e);
            }}
            placeholder={"Property ID"}
            styles={{ width: "200px" }}
          />
          {/* <Select
            className="location-search"
            value={selectedFilter?.property_id}
            onChange={(e) => handleChangeFilter("property_id", e.target?.value)}
            // displayEmpty
            style={{ minWidth: 160 }}
            options={optionsList?.properties || []}
          /> */}
          {/* <MenuItem value="">
              <em>Property ID</em>
            </MenuItem>
            {optionsList?.properties?.map((opt) => (
              <MenuItem key={opt.id} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))} */}
          <Select
            className="location-search"
            options={users || []}
            //   value={state}
            //   onChange={setState}
            value={selectedFilter?.room_categories}
            onChange={(e) => {
              handleChangeFilter("property_id", e);
            }}
            placeholder={"Room Categories"}
            styles={{ width: "200px" }}
          />
          {/* <Select
            className="location-search"
            value={selectedFilter?.room_categories}
            onChange={(e) =>
              handleChangeFilter("room_categories", e.target.value)
            }
            // value={city}
            // onChange={(e) => setCity(e.target.value)}
            displayEmpty
            style={{ minWidth: 160 }}
          >
            <MenuItem value="">
              <em>Room categories</em>
            </MenuItem>
            {users.map((opt) => (
              <MenuItem key={opt.id} value={opt.name}>
                {opt.name}
              </MenuItem>
            ))}
          </Select> */}
        </div>
        <div className="search-input">
          <input
            value={selectedFilter?.search}
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            // onChange={(e) => setSearch(e.target.value)}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
          />
          <img src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={isData}
        show={true}
      />
    </>
  );
}

export default UserBookingTransaction;
